import React, { useEffect } from 'react';
import HeroBanner from '../components/common/HeroBanner/HeroBanner';
import ServicesSection from '../components/home/ServicesSection/ServicesSection';
import './About.css';

const About = () => {
  useEffect(() => {
    document.title = 'NEST | About';
  }, []);
  return (
    <div className="about-page">
      <HeroBanner 
        title="About us" 
        breadcrumbs={['About us']}
      />
      <br/>
      <ServicesSection />
      <section className="ftco-section ftco-no-pt ftco-no-pb">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-md-6 p-md-5 img img-2 d-flex justify-content-center align-items-center about-image"></div>
            <div className="col-md-6 wrap-about py-md-5 ftco-animate">
              <div className="heading-section mb-5 pl-md-5">
                <span className="subheading">About us</span>
                <h2 className="mb-4">About Us – NEST Auto Transport</h2>
                <p>At NEST Auto Transport, we are dedicated to providing reliable, efficient, and hassle-free vehicle shipping services across the nation. With years of industry experience, we specialize in transporting vehicles safely and securely, whether for individuals, dealerships, military personnel, or businesses. Our commitment to excellence ensures timely deliveries, competitive pricing, and top-tier customer support.</p>
                <p>We offer both open and enclosed transport options, ensuring that your vehicle arrives in perfect condition, no matter the distance. Our team of highly skilled professionals carefully handles every shipment, using advanced tracking systems to provide real-time updates throughout the journey. Whether you're relocating, buying a vehicle online, or need fleet transportation, we have the expertise to get the job done right.</p>
                <p>At NEST Auto Transport, we don't just move vehicles—we deliver peace of mind. Let us handle your vehicle shipping needs with professionalism, safety, and care. Your vehicle is in good hands with us!</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;


